import { LockKeyhole } from "lucide-react";
import { Link } from "wouter";

/**
 * The one sentence a visitor sees where a paid member would see content.
 *
 * Said the same way everywhere — on a locked tab, under a locked list — so the
 * offer reads as one offer rather than as several differently worded walls. The
 * links change with the visitor: someone signed out is offered sign-in first (they
 * may already be a member); someone signed in but not paid is sent to membership.
 */
export default function MembershipLockNotice({
  what,
  isSignedIn,
  returnTo,
  align = "start",
}: {
  /** What is behind the lock, as the subject of the sentence: "Media & resources". */
  what: string;
  isSignedIn: boolean;
  /** Where sign-in should bring the visitor back to. */
  returnTo: string;
  align?: "start" | "center";
}) {
  const linkStyle: React.CSSProperties = { color: "#7DEAFF", fontWeight: 700 };
  return (
    <div
      role="note"
      style={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: align === "center" ? "center" : "flex-start",
        textAlign: align,
        gap: ".7rem",
        padding: "1rem 1.15rem",
        borderRadius: ".8rem",
        border: "1px solid rgba(255,255,255,.1)",
        background: "rgba(255,255,255,.03)",
      }}
    >
      <LockKeyhole size={20} aria-hidden="true" style={{ color: "#94A3B8", flex: "0 0 auto", marginTop: ".1rem" }} />
      <p style={{ margin: 0, color: "#CBD5E1", fontFamily: "'Inter', sans-serif", fontSize: "var(--chi-body-compact)", lineHeight: 1.55 }}>
        {what} {what.endsWith("s") ? "are" : "is"} included with membership.{" "}
        {isSignedIn ? (
          <Link href="/membership" style={linkStyle}>Join free</Link>
        ) : (
          <>
            <Link href={`/login?returnTo=${encodeURIComponent(returnTo)}`} style={linkStyle}>Sign in</Link>
            {" · "}
            <Link href="/membership" style={linkStyle}>Join free</Link>
          </>
        )}
      </p>
    </div>
  );
}
